<template>
  <modal-template>
    <template #header>
      <div>
        <div class="modal-header-style">
          <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
            <span>confirm product sort reset</span>
          </div>
          <div style="float:right;">
            <label class="action-icon-style" v-on:click="$emit('close', true)">
              <font-awesome-icon icon="xmark" size="xl"/>
              <span style="display: block;">close</span>
            </label>
          </div>
        </div>
      </div>
      <div style="width:100%;float:left;color:black;border-bottom:1px solid black;">
        <div style="width:100%;float:left;">
          <div style="font-size:larger;font-weight:bold;">
            <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
          </div>
          <div style="font-size:larger;font-weight:bold;">for user {{ username }}</div>
        </div>
        <div style="width:100%;float:left;padding-top:1%;">
          <span>
            serviced by <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}
          </span>
        </div>
      </div>
    </template>
    <template #body>
      <div>
        <p>Please confirm the following:</p>
        <ul>
          <li>you have selected the correct dairy, account, and username</li>
          <li>the user has closed their product list window</li>
        </ul>
      </div>
    </template>
    <template #footer>
      <div style="width:30%;margin:0 auto;">
        <button class="button" @click="resetProductSort">reset</button>
      </div>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'ProductSortResetConfirmation',
  props: ['account', 'username'],
  emits: ['close', 'apierror', 'apierrortext'],
  data: function () {
    return {}
  },
  components: {
    ModalTemplate,
  },
  methods: {
    resetProductSort: function () {
      this.axios
          .get('account/resetUserProductSequence',
              {
                params: {
                  dairyId: this.account.dairyId,
                  customerId: this.account.customerId,
                  username: this.username
                }
              })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })

      this.$emit('close', true)
    },
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    },
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
